// Chain ids used in this repository, keyed by the PascalCase display name of the chain (see CHAINS in index.ts)
export enum ChainId {
  Ethereum = 1,
  Optimism = 10,
  Flare = 14,
  Songbird = 19,
  Cronos = 25,
  Rootstock = 30,
  TelosEVM = 40,
  XDC = 50,
  BNBChain = 56,
  Viction = 88,
  BNBChainTestnet = 97,
  GnosisChain = 100,
  Fuse = 122,
  HECO = 128,
  Unichain = 130,
  Polygon = 137,
  Monad = 143,
  Sonic = 146,
  MantaPacific = 169,
  OpBNB = 204,
  Lens = 232,
  TAC = 239,
  Oasys = 248,
  Fantom = 250,
  Fraxtal = 252,
  Boba = 288,
  ZkSyncSepoliaTestnet = 300,
  ZkSyncEra = 324,
  Shape = 360,
  PulseChain = 369,
  WorldChain = 480,
  Rollux = 570,
  Astar = 592,
  Matchain = 698,
  FlowEVM = 747,
  Stable = 988,
  HyperEVM = 999,
  Metis = 1088,
  PolygonZkEVM = 1101,
  CORE = 1116,
  Moonbeam = 1284,
  Moonriver = 1285,
  Sei = 1329,
  Vana = 1480,
  GravityAlpha = 1625,
  Injective = 1776,
  Soneium = 1868,
  Ronin = 2020,
  Abstract = 2741,
  Morph = 2818,
  Citrea = 4114,
  RISE = 4153,
  Tempo = 4217,
  MegaETH = 4326,
  Beam = 4337,
  RobinhoodChain = 4663,
  IoTeX = 4689,
  Mantle = 5000,
  MantleTestnet = 5001,
  Somnia = 5031,
  Arc = 5042,
  ZetaChain = 7000,
  Kaia = 8217,
  Base = 8453,
  IOTAEVM = 8822,
  Shido = 9008,
  Plasma = 9745,
  ImmutableZkEVM = 13371,
  ApeChain = 33139,
  Mode = 34443,
  IgraNetwork = 38833,
  Mythos = 42018,
  Arbitrum = 42161,
  ArbitrumNova = 42170,
  Celo = 42220,
  Etherlink = 42793,
  Hemi = 43111,
  Avalanche = 43114,
  Ink = 57073,
  Linea = 59144,
  BOB = 60808,
  Treasure = 61166,
  Animechain = 69000,
  PolygonAmoy = 80002,
  Berachain = 80094,
  Blast = 81457,
  BaseSepolia = 84532,
  Chiliz = 88888,
  Doma = 97477,
  Plume = 98866,
  Taiko = 167000,
  KasplexZkEVM = 202555,
  ArbitrumSepolia = 421614,
  Scroll = 534352,
  Gensyn = 685689,
  Katana = 747474,
  EthereumSepolia = 11155111,
  OptimismSepolia = 11155420,
  FrameTestnet = 68840142,
  Aurora = 1313161554,
  Harmony = 1666600000,
}
